import PageLoading from "components/base/PageLoading";
import Cookies from "js-cookie";
import { SSO_AUTH_URL } from "pages/Auth/constants";
import { getAccessTokenByCustomerId } from "pages/Auth/utils";
import React, { useCallback, useEffect, useRef, useState } from "react";
import RestAPIClient from "services/RestAPIClient";
import { isBSP } from "utils/microApp";
import { AuthContext } from "./context";

interface Props {
  onLoaded?: () => void;
}

const AuthProvider: React.FC<Props> = (props) => {
  const { children, onLoaded } = props;
  const ssoHiddenIframeRef = useRef<HTMLIFrameElement | null>(null);

  const [status, setStatus] = useState<"PENDING" | "COMPLETE">("PENDING");

  const ssoDisabled =
    new URLSearchParams(window.location.search).get("sso") === "0" || isBSP;

  useEffect(() => {
    if (ssoDisabled) {
      onLoaded && onLoaded();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ssoDisabled]);

  const handleLoaded = useCallback(() => {
    setStatus("COMPLETE");
    const customerId = Cookies.get("customer_id");
    const init = async () => {
      try {
        if (!!customerId) {
          RestAPIClient.token =
            (await getAccessTokenByCustomerId(Number(customerId))) || "";
        }
      } catch (e) {
      } finally {
        onLoaded && onLoaded();
      }
    };
    init();
  }, [onLoaded]);

  return (
    <AuthContext.Provider value={{ ssoHiddenIframeRef, status }}>
      {!ssoDisabled && (
        <iframe
          id="sso-hidden-frame"
          ref={ssoHiddenIframeRef}
          src={SSO_AUTH_URL}
          style={{ display: "none" }}
          title="Tiki SSO"
          onLoad={handleLoaded}
        />
      )}
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
